import { useMutation, useQueryClient } from 'react-query';
import { get } from 'lodash'; // Replace with your actual utility function if necessary
import { useToast } from 'src/context/ToastProvider';
import { offlineDriveRejectRound } from 'src/apis/offlineDrive';

export const useOfflineDriveRejectRound = ({ onComplete }: { onComplete?: () => void }) => {
	const queryClient = useQueryClient();
	const toast = useToast();
	return useMutation(['offlineDriveRejectRound'], offlineDriveRejectRound, {
		onSuccess(data, variables) {
			if (onComplete) {
				onComplete();
			} else {
				toast({
					title: 'Round assigned successfully',
				});
			}
		},
		onError(error: Error) {
			const errorMessage = get(error, ['response', 'data', 'message'], error.message);
			toast({
				type: 'error',
				title: errorMessage,
			});
		},
	});
};
